// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class SuppSpecElecType {
    public static readonly SPECIAL: string = 'Special';
    public static readonly PRIMARY: string = 'Primary';
    public static readonly GENERAL: string = 'General';
}
